var map = {
	"./2023/autumn/poster/today_best_team_2.png": "585b",
	"./2024/autumn/poster/today_best_team_2.png": "6460",
	"./2024/summer/poster/today_best_team_2.png": "99b7",
	"./2024/winter/poster/today_best_team_2.png": "cc97",
	"./2025/spring/poster/today_best_team_2.png": "a423",
	"./2025/summer/poster/today_best_team_2.png": "2ab4d",
	"./2025/winter/poster/today_best_team_2.png": "8332"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "593e";